import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={
        'fixed top-0 left-0 right-0 z-50 transition-all duration-300 ' +
        (scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200'
          : 'bg-transparent')
      }
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16 max-w-7xl mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-900 font-heading font-bold text-xl whitespace-nowrap"
          >
            <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-white rounded-lg">
              <i className="ri-star-fill text-base"></i>
            </span>
            <span>精品一区</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={
                'px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 whitespace-nowrap ' +
                (location.pathname === '/'
                  ? 'text-primary-500 bg-primary-50'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100')
              }
            >
              首页
            </Link>

            <div className="relative" onMouseEnter={() => setCategoryOpen(true)} onMouseLeave={() => setCategoryOpen(false)}>
              <button
                className={
                  'px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 whitespace-nowrap flex items-center gap-1 ' +
                  (location.pathname.startsWith('/category')
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100')
                }
              >
                精选分类
                <i className={'ri-arrow-down-s-line text-sm transition-transform duration-200 ' + (categoryOpen ? 'rotate-180' : '')}></i>
              </button>
              {categoryOpen && (
                <div className="absolute top-full left-0 mt-1 bg-background-50 border border-background-200 rounded-lg py-2 w-48">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={'/category/' + cat.slug}
                      className="block px-4 py-2 text-sm text-foreground-600 hover:text-foreground-900 hover:bg-background-100 transition-colors duration-150 whitespace-nowrap"
                    >
                      <i className={cat.icon + ' mr-2 text-primary-500'}></i>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={
                'px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 whitespace-nowrap ' +
                (location.pathname === '/about'
                  ? 'text-primary-500 bg-primary-50'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100')
              }
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-2">
            <button className="w-9 h-9 flex items-center justify-center rounded-full text-foreground-500 hover:text-foreground-700 hover:bg-background-100 transition-colors duration-200 cursor-pointer">
              <i className="ri-search-line text-lg"></i>
            </button>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="打开菜单"
          >
            <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200 bg-background-50 py-3 px-2">
            <Link
              to="/"
              className="block px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-md hover:bg-background-100 transition-colors duration-150"
            >
              首页
            </Link>
            <div className="px-3 py-2.5 text-sm font-medium text-foreground-500">精选分类</div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={'/category/' + cat.slug}
                className="block px-6 py-2 text-sm text-foreground-600 hover:text-primary-500 rounded-md hover:bg-background-100 transition-colors duration-150"
              >
                <i className={cat.icon + ' mr-2'}></i>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="block px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-md hover:bg-background-100 transition-colors duration-150"
            >
              关于我们
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
}